export function formatNumberToPercentual(valor: number, casasDecimais: number = 2): string {
    return `${valor.toLocaleString("pt-BR", { style: 'percent' })}`;
}